<template>
  <NuxtLink :to="to" @click="handleClick">
    <slot></slot>
  </NuxtLink>
</template>

<script lang="ts" setup>
interface Props {
  to: string;
}
defineProps<Props>();

const emit = defineEmits(['click']);

function handleClick(event: MouseEvent) {
  emit('click', event);
}
</script>
